import React from 'react';
import MaterialList from '@mui/material/List';

import { ListProps } from './types';

const ListView: React.FC<React.PropsWithChildren<ListProps>> = React.forwardRef((props, ref) => {
  return (
    // @ts-ignore
    <MaterialList {...props} ref={ref} />
  );
});

export default ListView;
